export const Bindings = {
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	GlobalApiHTTPClient: Symbol("GlobalApiHTTPClient"),
	UserApiProvider: Symbol("UserApiProvider"),
	PasswordApiProvider: Symbol("PasswordApiProvider"),
	GameBarApiProvider: Symbol("GameBarApiProvider"),
	RankingsApiProvider: Symbol("RankingsApiProvider"),
	FriendsApiProvider: Symbol("FriendsApiProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	PubNubClientService: Symbol("PubNubClientService"),
	ContextualPromptBannerProvider: Symbol("ContextualPromptBannerProvider"),

	CountriesStore: Symbol("CountriesStore"),
	ContestsStore: Symbol("ContestsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	UserStore: Symbol("UserStore"),
	LocalizationStore: Symbol("LocalizationStore"),
	StaticContentStore: Symbol("StaticContentStore"),
	GameBarStore: Symbol("StaticContentStore"),
	PromotionStore: Symbol("PromotionStore"),
	RankingsStore: Symbol("RankingsStore"),
	RoundsStore: Symbol("RoundsStore"),
	TutorialStore: Symbol("TutorialStore"),
	ContextualPromptBannerStore: Symbol("ContextualPromptBannerStore"),

	AuthController: Symbol("AuthController"),
	RegistrationController: Symbol("RegistrationController"),
	MyAccountController: Symbol("MyAccountController"),
	SecretGateController: Symbol("SecretGateController"),
	HelpController: Symbol("HelpController"),
	HelpListController: Symbol("HelpListController"),
	ContactUsController: Symbol("ContactUsController"),
	ChecksumStore: Symbol("ChecksumStore"),
	LiveScoreController: Symbol("LiveScoreController"),
	ForgotPasswordController: Symbol("ForgotPasswordController"),
	ResetPasswordController: Symbol("ResetPasswordController"),
	SessionController: Symbol("SessionController"),
	BootstrapController: Symbol("BootstrapController"),
	ModalsStore: Symbol("ModalsStore"),
	ModalErrorController: Symbol("ModalErrorController"),
	ModalConfirmController: Symbol("ModalConfirmController"),
	LocalizationController: Symbol("LocalizationController"),
	HeaderController: Symbol("HeaderController"),
	PlayersBarController: Symbol("PlayersBarController"),
	GameController: Symbol("GameController"),
	PlayersBarPlayerController: Symbol("PlayersBarPlayerController"),
	ModalStatsController: Symbol("ModalStatsController"),
	ModalRosterStatsController: Symbol("ModalRosterStatsController"),
	ContestPlayerStatsStore: Symbol("ContestPlayerStatsStore"),
	PlayerStatsStore: Symbol("PlayerStatsStore"),
	RosterStore: Symbol("RosterStore"),
	RosterStoreSingle: Symbol("RosterStoreSingle"),
	RosterProvider: Symbol("RosterProvider"),
	BackdoorController: Symbol("BackdoorController"),
	TournamentsStore: Symbol("TournamentsStore"),
	LeaderboardsLayoutController: Symbol("LeaderboardsLayoutController"),
	LeaderboardController: Symbol("LeaderboardController"),
	LeaderboardNavigationController: Symbol("LeaderboardNavigationController"),
	MissedPlayersController: Symbol("MissedPlayersController"),
	SpinnerController: Symbol("SpinnerController"),
	PlayerStatsController: Symbol("PlayerStatsController"),
	LandingController: Symbol("LandingController"),
	ModalTmpGifController: Symbol("ModalTmpGifController"),
	WheelViewController: Symbol("WheelViewController"),
	RosterListViewController: Symbol("RosterListViewController"),
	ModalPromotedController: Symbol("ModalPromotedController"),
	ModalSecondaryRegistrationController: Symbol("ModalSecondaryRegistrationController"),
	ModalScoringController: Symbol("ModalScoringController"),
	RoundStatsController: Symbol("RoundStatsController"),
	RoasterPlayerController: Symbol("RoasterPlayerController"),
	ContestsNavigationController: Symbol("ContestsNavigationController"),
	RosterPlayerTournamentInfoController: Symbol("RosterPlayerTournamentInfoController"),
	CalendarPickerController: Symbol("CalendarPickerController"),
	ModalTutorialController: Symbol("ModalTutorialController"),
	TutorialSliderController: Symbol("TutorialSliderController"),
	LeagueLevelsController: Symbol("LeagueLevelsController"),
	RoundBadgesController: Symbol("RoundBadgesController"),
	LevelContestRosterController: Symbol("LevelContestRosterController"),
	RosterLevelViewController: Symbol("RosterLevelViewController"),
	RoundSummaryStore: Symbol("RoundSummaryStore"),
	LeaderboardRowController: Symbol("LeaderboardRowController"),
	UserRosterStore: Symbol("UserRosterStore"),
	LeaderboardRosterViewController: Symbol("LeaderboardRosterViewController"),
	LeaderboardProfileNavigationController: Symbol("LeaderboardProfileNavigationController"),
	GameBarController: Symbol("GameBarController"),
	PlayerCalculations: Symbol("PlayerCalculations"),
	HeadToHeadController: Symbol("HeadToHeadController"),
	TomorrowGameController: Symbol("TomorrowGameController"),
	TomorrowNavigationController: Symbol("TomorrowNavigationController"),
	RosterListLayoutViewTomorrowController: Symbol("RosterListLayoutViewTomorrowController"),
	ModalTomorrowGameController: Symbol("ModalTomorrowGameController"),
	ContestLocksStringController: Symbol("ContestLocksStringController"),
	H2hNavigationController: Symbol("H2hNavigationController"),
	UserLevelBadgeController: Symbol("UserLevelBadgeController"),
	FriendsInviteWidgetController: Symbol("FriendsInviteWidgetController"),
	H2hManageGamesController: Symbol("H2hManageGamesController"),
	ChallengeGameController: Symbol("ChallengeGameController"),
	FriendsStore: Symbol("FriendsStore"),
	H2hFriendsController: Symbol("H2hFriendsController"),
	FriendPlayRowController: Symbol("FriendPlayRowController"),
	SnackbarStore: Symbol("SnackbarStore"),
	SnackbarController: Symbol("SnackbarController"),
	PubNubHocController: Symbol("PubNubHocController"),
	H2hProvider: Symbol("H2hProvider"),
	H2hStore: Symbol("H2hStore"),
	ModalH2hChallengeController: Symbol("ModalH2hChallengeController"),
	ChallengeInviteController: Symbol("ChallengeInviteController"),
	H2hChallengeViewController: Symbol("H2hChallengeViewController"),
	H2hRosterMatchUpViewController: Symbol("H2hRosterMatchUpViewController"),
	HocFriendsRedirectController: Symbol("HocFriendsRedirectController"),
	ContextualPromptBannerController: Symbol("ContextualPromptBannerController"),
	ModalAcceptTermsRegistrationController: Symbol("ModalAcceptTermsRegistrationController"),
};
